/**
 * Ordenação da grade Doca Expedição (#MT-556E374).
 * O índice é o data-index do cabeçalho. Negativo = decrescente, como o CRUD envia em `sort`.
 */

const NUMERIC_INDEXES = new Set([1, 2, 8, 9]);

/**
 * @param {string} query
 * @returns {number|null}
 */
export function dockSortFromQuery(query)
{
	const qs = new URLSearchParams(String(query || '').replace(/^\?/, ''));
	if (!qs.has('sort'))
		return null;
	const n = Number(qs.get('sort'));
	return Number.isFinite(n) ? n : null;
}

/**
 * @param {object[]} rows
 * @param {number|null} sort
 * @param {Map<string, string>} [companyNicks]
 * @returns {object[]}
 */
export function sortDockRows(rows, sort, companyNicks)
{
	if (!Array.isArray(rows) || sort == null || !Number.isFinite(Number(sort)))
		return Array.isArray(rows) ? rows : [];
	const n = Number(sort);
	const desc = n < 0;
	const index = Math.abs(n);
	const numeric = NUMERIC_INDEXES.has(index);
	const nicks = companyNicks instanceof Map ? companyNicks : new Map();
	return rows.slice().sort((a, b) => compareRows(a, b, index, numeric, desc, nicks));
}

/**
 * @param {object} row
 * @param {number} index
 * @param {Map<string, string>} nicks
 * @returns {string|number|null}
 */
function sortKey(row, index, nicks)
{
	switch (index)
	{
		case 0:
			return text(nicks.get(String(row?.company_id)) || '');
		case 1:
			return numberOrNull(row?.id);
		case 2:
			return numberOrNull(row?.order_id);
		case 3:
			return text(row?.reference);
		case 4:
			return text(row?.customer_nick || row?.customer_name);
		case 5:
			return text(row?.carrier_nick || row?.carrier_name);
		case 6:
			return text(row?.dock_warehouse_name);
		case 7:
			return text(row?.dock_address);
		case 8:
			return numberOrNull(row?.status);
		case 9:
			return timeOrNull(row?.created_on);
		case 10:
			return text(row?.delivery_sector);
		default:
			return numberOrNull(row?.id);
	}
}

/**
 * @param {object} a
 * @param {object} b
 * @param {number} index
 * @param {boolean} numeric
 * @param {boolean} desc
 * @param {Map<string, string>} nicks
 * @returns {number}
 */
function compareRows(a, b, index, numeric, desc, nicks)
{
	const ka = sortKey(a, index, nicks);
	const kb = sortKey(b, index, nicks);
	const aEmpty = ka == null || ka === '';
	const bEmpty = kb == null || kb === '';
	if (aEmpty || bEmpty)
	{
		if (aEmpty && bEmpty)
			return (Number(a?.id) || 0) - (Number(b?.id) || 0);
		return aEmpty ? 1 : -1;
	}
	let cmp = numeric
		? ka - kb
		: String(ka).localeCompare(String(kb), 'pt-BR', { numeric: true, sensitivity: 'base' });
	if (cmp === 0)
		cmp = (Number(a?.id) || 0) - (Number(b?.id) || 0);
	else if (desc)
		cmp = -cmp;
	return cmp;
}

/**
 * @param {unknown} value
 * @returns {string}
 */
function text(value)
{
	return String(value ?? '').trim();
}

/**
 * @param {unknown} value
 * @returns {number|null}
 */
function numberOrNull(value)
{
	if (value == null || value === '')
		return null;
	const n = Number(value);
	return Number.isFinite(n) ? n : null;
}

/**
 * @param {unknown} value
 * @returns {number|null}
 */
function timeOrNull(value)
{
	if (value == null || value === '')
		return null;
	const t = Date.parse(String(value).trim().replace(' ', 'T'));
	return Number.isFinite(t) ? t : null;
}
